<template>
  <div class="wrapper">
    <div class="pb-0">
      <div>
        <h5 class="p-2 text-white text-bold title">
          युनिकोड बाट प्रिती
        </h5>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-6 col-sm-12 col-xs-12">
          <div class="px-3 spacer d-flex justify-content-between">
            <label for="">युनिकोड फन्टका अक्षरहरु </label>
            <label> </label>
          </div>
          <textarea
            rows="15"
            id="unicode"
            v-model="unicodeString"
            class="form-control"
          >
          </textarea>
        </div>
        <div class="col-lg-12 col-md-6 col-sm-12 col-xs-12 py-2">
          <div class="spacer px-3 d-flex justify-content-between">
            <label for=""> प्रीति फन्टका अक्षरहरू </label>
            <label>Special Letters :र्‍य र्‍ ऋ क्ष ज्ञ ॐ ण । ॠ ङ ञ </label>
          </div>

          <textarea
            rows="14"
            id="preeti"
            v-model="preetiString"
            class="form-control"
          >
          </textarea>
        </div>
      </div>
    </div>
    <Intro mode="u2p" />
  </div>
</template>

<script>
  import Intro from "./Intro";
  const { unicodeToPreeti } = require("./unicode_to_preeti.js");
  export default {
    components: { Intro },
    data() {
      return {
        unicodeString: "यहाँ युनिकोड मा लेख्नुहोस !",
      };
    },
    computed: {
      preetiString() {
        return unicodeToPreeti(this.unicodeString);
      },
    },
  };
</script>

<style>
  #preeti {
    font-family: "Preeti";
    font-size: 1.5em;
  }
  #unicode {
    font-size: 1em;
    /* font-family: "Mukta"; */
  }
</style>
